const errors = [];
const MAX_ERRORS = 50;

export function logError(error, context = 'Unknown', additionalInfo = {}) {
  const isErrorObj = error instanceof Error;
  const errorInfo = {
    message: isErrorObj ? error.message : error,
    context,
    timestamp: new Date().toISOString(),
    stack: isErrorObj ? error.stack : undefined,
    ...additionalInfo,
  };

  errors.push(errorInfo);
  if (errors.length > MAX_ERRORS) errors.shift();

  return errorInfo;
}

export function getUserFriendlyMessage(error, translations = null) {
  const msg = typeof error === 'string' ? error : error?.message || '';
  if (!msg) return translations?.errors?.genericError || 'An error occurred';

  if (translations?.errors) {
    if (msg.includes('network') || msg.includes('fetch'))
      return translations.errors.networkError;
    if (msg.includes('permission') || msg.includes('auth'))
      return translations.errors.permissionError;
    if (msg.includes('not found') || msg.includes('No such document'))
      return translations.errors.notFoundError;
    return translations.errors.genericError;
  }

  if (msg.includes('network') || msg.includes('fetch')) return 'Network error';
  if (msg.includes('permission') || msg.includes('auth'))
    return 'Permission denied';
  if (msg.includes('not found') || msg.includes('No such document'))
    return 'Data not found';

  return 'An error occurred';
}

export function clearErrors() {
  errors.length = 0;
}

export function getErrors() {
  return errors.slice();
}

export const errorHandler = {
  logError,
  getUserFriendlyMessage,
  clearErrors,
  getErrors,
};
